<template>
<div>
  <div class="content-header text-center">
    <div class="float-start" v-if="projectrefer"><button @click="backToProjects(projectrefer)" class="btn btn-blank"><i class="fas fa-arrow-left"></i> {{projectrefer}} Details</button></div>
    <h2>{{ passedData }}</h2>
  </div>
  <div class="tabbed-padding">
    <ul class="nav nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link"  :class="{active: tabOne}" @click="lifestyletab">American Lifestyles</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{active: tabTwo}" @click="summarytab">Summary Sociometrics</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{active: tabThree}" @click="sociometrictab">Full Sociometrics</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{active: tabSix}" @click="powerindextab">Power Index</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{active: tabSeven}" @click="insightstab">Insights</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{active: tabFive}" @click="personastab" v-if="ispersonas">Personas</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{active: tabFour}" @click="heatmaptab">Geography</a>
      </li>
    </ul>
    <div class="tab-content py-5 px-2">
        <div class="container-fluid">
          <component :is="currentTab" v-bind:passedData="passedData"></component>
        </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from "axios";
import ReportShellLifestyle from "./ReportShellLifestyle.vue";
import ReportShellSummary from "./ReportShellSummary.vue";
import ReportShellSociometric from "./ReportShellSociometric.vue";
import ReportShellMap from "./ReportShellMap.vue";
import ReportShellPersonas from "./ReportShellPersonas.vue";
import PowerIndexReport from "./ReportShellPowerIndex.vue";
import ReportShellInsights from "./ReportShellInsights.vue";
export default {
  name: "reportshell",
  components: { ReportShellLifestyle, ReportShellSummary, ReportShellSociometric, ReportShellMap, ReportShellPersonas, PowerIndexReport, ReportShellInsights },
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      },
    },
    isAdmin: {
      type: Boolean,
      default() {
        return false
      }
    },
    projectrefer: ''
  },
  data() {
    return {
      currentTab: ReportShellLifestyle,
      tabOne: true,
      tabTwo: false,
      tabThree: false,
      tabFour: false,
      tabFive: false,
      tabSix: false,
      tabSeven: false,
      ispersonas: false
    };
  },
  methods: {
    lifestyletab() {
      this.currentTab = ReportShellLifestyle;
      this.tabOne = true;
      this.tabTwo = false;
      this.tabThree = false;
      this.tabFour = false;
      this.tabFive = false;
      this.tabSix = false;
      this.tabSeven = false;
    },
    summarytab() {
      this.currentTab = ReportShellSummary;
      this.tabTwo = true;
      this.tabOne = false;
      this.tabThree = false;
      this.tabFour = false;
      this.tabFive = false;
      this.tabSix = false;
      this.tabSeven = false;
    },
    sociometrictab() {
      this.currentTab = ReportShellSociometric;
      this.tabThree = true;
      this.tabOne = false;
      this.tabTwo = false;
      this.tabFour = false;
      this.tabFive = false;
      this.tabSix = false;
      this.tabSeven = false;
    },
    heatmaptab() {
      this.currentTab = ReportShellMap;
      this.tabFour = true;
      this.tabOne = false;
      this.tabTwo = false;
      this.tabThree = false;
      this.tabFive = false;
      this.tabSix = false;
      this.tabSeven = false;
    },
    personastab() {
      this.currentTab = ReportShellPersonas;
      this.tabFive = true;
      this.tabFour = false;
      this.tabOne = false;
      this.tabTwo = false;
      this.tabThree = false;
      this.tabSix = false;
      this.tabSeven = false;
    },
    powerindextab() {
      this.currentTab = PowerIndexReport;
      this.tabSix = true;
      this.tabOne = false;
      this.tabTwo = false;
      this.tabThree = false;
      this.tabFour = false;
      this.tabFive = false;
      this.tabSeven = false;
    },
    insightstab() {
      this.currentTab = ReportShellInsights;
      this.tabSeven = true;
      this.tabOne = false;
      this.tabTwo = false;
      this.tabThree = false;
      this.tabFour = false;
      this.tabFive = false;
      this.tabSix = false;
    },
    backToProjects(referval) {
      this.$emit('customChangeProject', {shell: 'ProjectDetails', dataset: referval})
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  mounted() {
      this.scrollToTop();
      // console.log('checking admin status '+this.isAdmin);
      axios.get("/check_personas", {
        params: { report: this.passedData },
      })
      .then((response) => {
        // console.log('the checked response is '+response.data);
        if(response.data == true) {
          console.log('found personas');
          this.ispersonas = true;
        }
      });
    }
};
</script>